import { AboutPageWrapper, AboutPageTable, AboutPageTitle, AboutPageInformation, AboutPagePicture, AboutPageContent, AboutPageText, ResumeButton, SkillsSection, 
         SkillsContainer, ImportantWord, InfoStrip, InfoStripImage,
         GreenDot,
         InfoStripText,
         SocialLink,
         SocialLinkContainer,
         ScrollableAboutPageSection,
         AboutTitle,
         TabWrapper,
         TabHR,
         AboutContentWrapper,
         JobImage,
         VerticalLine,
         JobTitle,
         HorizontalContainer,
         VerticalSpacer,
         JobDescription,
         TechnologyIcon,
         RelImagesContainer,
         HorizontalLine,
         PorjectDescriptionPoint,
         InfoLabel,
         SkillImage} from "./about-page.styles";
import { MediaImage } from "../social-media-bar/social-media-bar.styles";


import { useState } from "react";

import PFP from '../../assets/personal-picture.png'
import Resume from '../../assets/Ali-Ghosn-Resume.pdf'

import About from '../../assets/profile-user.png'
import Jobs from '../../assets/bag.png'
import Projects from '../../assets/rocket.png'
import Socials from '../../assets/phone-call.png'
import Skills from '../../assets/solution.png'

import GameDevSkillIcon from '../../assets/coding.png'

const AboutPage = () => {
    
    const [activeTab, setActiveTab] = useState('About')

    const SocialInfo = [
        {
            link: 'https://github.com/AliGhosn1',
            icon: 'https://iconvulture.com/wp-content/uploads/2017/12/github-sign.svg'
        },
        {
            link: 'https://github.com/AliGhosn1',
            icon: 'https://iconvulture.com/wp-content/uploads/2017/12/github-sign.svg'
        },
        {
            link: 'https://github.com/AliGhosn1',
            icon: 'https://iconvulture.com/wp-content/uploads/2017/12/github-sign.svg'
        },
        {
            link: 'https://github.com/AliGhosn1',
            icon: 'https://iconvulture.com/wp-content/uploads/2017/12/github-sign.svg'
        },
        {
            link: 'https://github.com/AliGhosn1',
            icon: 'https://iconvulture.com/wp-content/uploads/2017/12/github-sign.svg'
        },
    ]

    const TabInfo = [
        {
            title: 'About',
            icon: About,
        },
        {
            title: 'Jobs',
            icon: Jobs,
        },
        {
            title: 'Projects',
            icon: Projects,
        },
        {
            title: 'Skills',
            icon: Skills
        },
        {
            title: 'Socials',
            icon: Socials,
        }
    ]

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    }

    return(
        <AboutPageWrapper>
            <InfoStrip>
                <InfoStripImage src={PFP} />
                <InfoStripText>
                    <GreenDot>●</GreenDot> Available for work
                </InfoStripText>
                <InfoStripText style={{fontSize: '1.7em'}}>
                    Ali Ghosn
                </InfoStripText>
                <SocialLinkContainer>
                    {
                        TabInfo.map((tab) => (
                            <TabWrapper src={tab.icon} alt={tab.title} onClick={() => handleTabClick(tab.title)} style={{cursor: 'pointer', filter: activeTab === tab.title ? "brightness(0) saturate(100%) invert(76%) sepia(89%) saturate(1036%) hue-rotate(101deg) brightness(97%) contrast(91%)" : "brightness(0) invert(1)"}} />
                        ))
                    }
                </SocialLinkContainer>
                <ResumeButton href={Resume} download>Download My Resumé</ResumeButton>
            </InfoStrip>
            <ScrollableAboutPageSection>
                {
                    activeTab === 'About' && AboutCard() ||
                    activeTab === 'Jobs' && JobsCard() ||
                    activeTab === 'Skills' && SkillsCard() ||
                    activeTab === 'Projects' && ProjectsCard() ||
                    activeTab === 'Socials' && SocialsCard()
                }
            </ScrollableAboutPageSection>
            
            {/* <SkillsSection>
                <AboutPageTitle>SKILLS</AboutPageTitle>
                <SkillsContainer>
                    {
                        SKILLS.map((skill) => (
                            <SkillCard skill={skill} />
                        ))
                    }
                </SkillsContainer>
            </SkillsSection> */}
        </AboutPageWrapper>
    )
}

const AboutCard = () => (
    <>
        <AboutTitle>I'm Ali Ghosn, <br /><ImportantWord>A Web & Game Developer.</ImportantWord></AboutTitle>
        <TabHR />
        <AboutPageInformation>
            I’m passionate about software development and love working with others to create tools, applications, and systems that solve real problems. Contributing to open-source projects is one of my favorite ways to learn, share knowledge, and be part of a community working toward something bigger than any individual. I thrive on collaboration, exchanging ideas, and turning concepts into practical, reliable, and meaningful software. <br /><br />

            Beyond general development, I’m fascinated by interactive experiences. I enjoy designing games and applications that are engaging, intuitive, and immersive—whether it’s crafting branching narratives, adaptive systems, or environments that respond to user actions. I love exploring ways to make interactions feel natural yet surprising and seeing how small design choices can create memorable experiences for users.<br /><br />

            For me, development isn’t just about finishing projects—it’s about creating software and experiences that leave a lasting impact. I’m driven by curiosity, experimentation, and the joy of seeing ideas come to life, whether through collaborative tools, open-source contributions, or immersive interactive worlds.
        </AboutPageInformation>
    </>
)

const JobsCard = () => {
    const JobInfo = [
        {
            title: 'Lead Game Developer',
            company: 'Dungeon Door Studios',
            duration: 'Oct 2024 - Present',
            description: 'I led the development of multiple indie game projects from concept to beta, using Unity and Godot to build complex gameplay mechanics and interactive systems. I designed reusable architectures with patterns like Singleton, Factory, and Object Pooling to enhance performance and maintainability, while managing cross-functional workflows and coordinating teams to boost development efficiency by 30%. Additionally, I established coding standards, version control strategies, and collaborative pipelines, created custom tools to streamline asset integration and level design, and conducted iterative playtesting to drive design improvements, optimizations, and bug fixes.',
            icon: "https://styles.redditmedia.com/t5_die0j6/styles/profileIcon_caud9193c8te1.png?width=256&height=256&frame=1&auto=webp&crop=&s=1d8320b8a842be2952e7e7d16cfb787afade7aa9"
        },
        {
            title: 'Software Engineer Intern',
            company: 'Dayforce',
            duration: 'Jan 2024 - Jan 2025',
            description: 'I developed user-friendly, visually appealing front-end interfaces using React, focusing on accessibility and a seamless user experience. I optimized SQL queries to manage over 10,000 database entries efficiently, improving system performance, and documented new features and designs through detailed wiki pages to streamline knowledge transfer and onboarding. Additionally, I adapted to a 15+ member Scrum team, actively contributing to stand-ups, sprint planning, and retrospectives to enhance project delivery efficiency.',
            icon: "https://media.trustradius.com/product-logos/nn/Zl/WTX9F0E3045I.PNG"
        },
        {
            title: 'Co-Founder & Web Developer',
            company: 'Boxtia',
            duration: 'May 2022 - Oct 2024',
            description: 'I co-founded and led a startup, collaborating with a team to design and deploy dynamic web apps for local businesses, driving their digital transformation. I implemented React to create intuitive, visually appealing interfaces, boosting customer retention by 20%, and ensured the highest level of data security through carefully designed MongoDB databases.',
            icon: "https://media.licdn.com/dms/image/v2/D560BAQHY5N6jaODfvw/company-logo_200_200/company-logo_200_200/0/1724743131477?e=2147483647&v=beta&t=GZxM4YjG_n87Q0CuEDyXWjvaKcYv_zd94wqZkPa59Nk"
        },
        {
            title: 'Software Engineer Intern',
            company: 'Project: Empower',
            duration: 'May 2023 - Aug 2023',
            description: 'I designed and managed Express servers to ensure fast and reliable communication between front-end and back-end systems, handling high volumes of API calls with sub-50ms response times. I also built and secured MongoDB databases, implementing encryption to protect sensitive customer data, while using Mongoose to optimize database operations and schema design—boosting CRUD performance by 30% and maintaining data consistency and integrity.',
            icon: "https://media.licdn.com/dms/image/v2/C560BAQEtTDXCpKPNuQ/company-logo_200_200/company-logo_200_200/0/1660941010673?e=2147483647&v=beta&t=9wE2Z8LChKDDU5RsqLe9g3L6Fk4pAr-1aMN6_GMdDc4"
        },
    ]

    return (
        <>
            <AboutTitle><ImportantWord>Work Experience</ImportantWord></AboutTitle>
            <TabHR />
            <AboutPageInformation>
                {
                    JobInfo.map((job) => (
                        <AboutContentWrapper>
                            <JobImage src={job.icon} alt={job.title} />
                            <VerticalLine />
                            <div>
                                <HorizontalContainer><JobTitle>{job.title}</JobTitle><AboutPageText style={{margin: 0}}>{job.duration}</AboutPageText></HorizontalContainer>
                                <AboutPageText><ImportantWord>{job.company}</ImportantWord></AboutPageText>
                                <VerticalSpacer />
                                <JobDescription>{job.description}</JobDescription>
                            </div>
                        </AboutContentWrapper>
                    ))
                }
            </AboutPageInformation>
        </>
    )
}

const ProjectsCard = () => {
    const ProjectsInfo = [
        {
            name: 'RentRight',
            shortDescription: 'Full stack property management website',
            githubLink: 'https://github.com/AliGhosn1/RentRight-Front-End',
            liveLink: 'https://rentrightt.netlify.app/',
            technologies: ['React', 'Node', 'Express', 'MongoDB', 'Typescript'],
            points: [
                'Engineered a feature-rich full stack property management website with comprehensive CRUD functionality, allowing users to efficiently manage properties and culminating in a 40% reduction in administrative workload',
                'Developed the front-end leveraging Refine, a powerful library, to simplify and enhance the readability of API calls, producing a 20% reduction in development time and improved code maintainability',
                'Implemented an efficient back-end server setup using Express, enabling seamless data retrieval and response handling, resulting in an average API response time of less than 100 milliseconds',
            ]
        },
        {
            name: 'CRWN Clothing',
            shortDescription: 'Secure E-commerce website',
            githubLink: 'https://github.com/AliGhosn1/EcommerceWebsite',
            liveLink: 'https://crwn-shop.netlify.app/',
            technologies: ['React', 'Redux', 'Node', 'Firebase'],
            points: [
                'Developed a fully functional front-end web application utilizing advanced React concepts, serving as a sample ecommerce site with a user-friendly interface, bringing about a 30% increase in user engagement',
                'Employed Redux for state management, enabling seamless value synchronization across all components and improving application performance by reducing unnecessary re-rendering',
                'Implemented Firebase to efficiently store and manage user and product information, utilizing NPM packages to retrieve and display saved data, triggering a 40% escalation in record retrieval speed'
            ]
        },
    ]

    const TechnologyIcons = {
        'React': 'https://cdn.iconscout.com/icon/free/png-256/free-react-icon-svg-png-download-282599.png?f=webp',
        'Node': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-bSt16XVIR9526s9Rs6OUTds5FV8oZ_vX1w&s',
        'Express': 'https://images.tute.io/media/topics/icons/express-js.png',
        'MongoDB': 'https://images.seeklogo.com/logo-png/48/2/mongodb-logo-png_seeklogo-481256.png',
        'Typescript': 'https://cdn-icons-png.flaticon.com/512/919/919832.png',
        'Redux': 'https://img.icons8.com/?size=512&id=jD-fJzVguBmw&format=png',
        'Firebase': 'https://cdn.iconscout.com/icon/free/png-256/free-firebase-1-282796.png?f=webp'
    }

    return (
        <>
            <AboutTitle><ImportantWord>Projects</ImportantWord></AboutTitle>
            <TabHR />
            <AboutPageInformation>
                {
                    ProjectsInfo.map((project) => (
                        <AboutContentWrapper>
                            <div style={{width: '100%'}}>
                                <HorizontalContainer>
                                    <div>
                                        <JobTitle><ImportantWord>{project.name}</ImportantWord></JobTitle>
                                        <AboutPageText style={{margin: 0}}>{project.shortDescription}</AboutPageText>

                                    </div>
                                    <RelImagesContainer>
                                        <a href={project.githubLink} target="_blank"><MediaImage src="https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_960_720.png"/></a>
                                        <a href={project.liveLink} target="_blank"><MediaImage src="https://media.istockphoto.com/id/938353738/vector/external-link-icon-user-will-know-they-are-leaving-the-app-to-visit-an-external-website.jpg?s=612x612&w=0&k=20&c=YfVnymm9EjVjS12tHKhNnCxwVrgZSCK92lEZu21Mx5g="/></a>
                                    </RelImagesContainer>
                                </HorizontalContainer>
                                <VerticalSpacer />
                                <HorizontalLine />
                                <VerticalSpacer />
                                <AboutPageText>
                                    <HorizontalContainer style={{justifyContent: 'left', gap: '20px'}}>
                                    {
                                        project.technologies.map((tech) => (
                                            <TechnologyIcon src={TechnologyIcons[tech]} alt={tech} title={tech} />
                                        ))
                                    }
                                    </HorizontalContainer>
                                </AboutPageText>
                                <VerticalSpacer />
                                <VerticalSpacer />
                                <JobDescription style={{paddingLeft: '20px'}}>
                                    {
                                        project.points.map((point) => (
                                            <PorjectDescriptionPoint>{point}</PorjectDescriptionPoint>
                                        ))
                                    }
                                </JobDescription>
                            </div>
                        </AboutContentWrapper>
                    ))
                }
            </AboutPageInformation>
        </>
    )
}

const SocialsCard = () => {
    const socials = [
        {
            icon: "https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_960_720.png",
            rel: "https://github.com/AliGhosn1"
        },
        {
            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/960px-LinkedIn_logo_initials.png",
            rel: "https://www.linkedin.com/in/ali-ghosn-b53402217/"
        },
    ]
    return (
    <>
        <AboutTitle><ImportantWord>Where You Can</ImportantWord> <br></br>Find Me</AboutTitle>
        <TabHR />
        <AboutPageInformation>
            I’m always looking to collaborate on projects and ideas, so feel free to reach out to me. Whether it’s developing unique game concepts, building engaging interactive experiences, or working on creative and functional web projects, I enjoy teaming up with others to bring ideas to life. Collaboration is where the best innovations happen, and I’d love to connect with like-minded creators who are passionate about pushing projects forward.
        </AboutPageInformation>
        <AboutContentWrapper style={{marginTop: "auto"}}>
            <RelImagesContainer style={{justifyContent: "center", width: "100%"}}>
                <InfoLabel>alighosnworks@gmail.com</InfoLabel>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                    {
                        socials.map((social) => (
                            <a style={{display: "flex", alignItems: "center", justifyContent: "center"}} href={social.rel} target="_blank"><MediaImage src={social.icon}/></a>
                        ))
                    }
                </div>
                <InfoLabel>(226) 506-1603</InfoLabel>
            </RelImagesContainer>
        </AboutContentWrapper>
    </>
    )
}

const SkillsCard = () => {
    const Skills = [
        {
            name: 'Front-End',
            tools: ['HTML/CSS','Bootstrap', 'React.js', 'Redux', 'TailWind' ],
            icon: 'https://i.imgur.com/8ldLMlC.png'
        },
        {
            name: 'Back-End',
            tools: ['Python', 'MongoDB', 'Firebase','SQLite3', 'Express.js'],
            icon:'https://i.imgur.com/odOmIFN.png'
        },
        {
            name: 'Tools',
            tools: ['GraphQL', 'Github', 'Bash', 'Linux', 'Java'],
            icon: 'https://i.imgur.com/fxS4cCu.png'

        },
        {
            name: 'Design',
            tools: ['Photoshop', 'Gimp', 'Tiled', 'Word', 'Excel'],
            icon: 'https://i.imgur.com/pTWXgRU.png'
        },
        {
            name: 'Game Dev',
            tools: ['Unity', 'Godot', 'GDScript', 'Patterns', 'Management'],
            icon: GameDevSkillIcon
        },
    ]

    return (
        <>
            <AboutTitle><ImportantWord>Technologies Overview</ImportantWord></AboutTitle>
            <TabHR />
            <AboutPageInformation style={{flexDirection: 'row', flexWrap: 'nowrap', overflowX: 'auto', marginBottom: '0px'}}>
                {
                    Skills.map((skill) => (
                        <AboutContentWrapper style={{flexDirection: 'column', alignItems: 'center', width: '250px', flexShrink: '0', marginBottom: '30px'}}>
                            <SkillImage src={skill.icon} alt={skill.name} />
                            <HorizontalLine />
                            <div>
                                <HorizontalContainer><JobTitle>{skill.name}</JobTitle></HorizontalContainer>
                                <VerticalSpacer />
                                <JobDescription style={{ marginBlockEnd: "0"}}>
                                    {
                                        skill.tools.map((tool) => (
                                            <div><ImportantWord style={{fontSize: '1.2em', textTransform: "capitalize"}}>{tool}</ImportantWord></div>
                                        ))
                                    }
                                </JobDescription>
                            </div>
                        </AboutContentWrapper>
                    ))
                }
            </AboutPageInformation>
        </>
    )
}

export default AboutPage;